import 'whatwg-fetch';
import Constants from '../model/AppConfiguration';
import StatusCodes from '../model/StatusCodes';
import AllFlightsConverter from '../converter/AllFlightsConverter';
import ResponseError from './ResponseError';
import Request from './Request';
import convert from 'xml-js';

export default { getAllFlights: getAllFlights };

function getAllFlights (reservationId, routeId, passengerId) {
  reservationId = reservationId || 0;
  let currentMillis = new Date().getTime();
  let url = `${
    Constants.BASE_URL
  }?fuseaction=airres.getFlights&timestamp=${currentMillis}&reservationid=${reservationId}&routeId=${routeId}&Contact_ObjectID=4646`;
  if (passengerId) {
    url = `${
      Constants.BASE_URL
    }?fuseaction=airres.getFlights&timestamp=${currentMillis}&reservationid=${reservationId}&routeId=${routeId}&Contact_ObjectID=${passengerId}`;
  }
  return fetch(url, Request.getBase())
    .then(response =>
      response
        .text()
        .then(response => {
          let responseData = convert.xml2json(response, { compact: true, spaces: 4 });

          responseData = JSON.parse(responseData);
          responseData = responseData ? responseData.result : responseData;

          let status =
            responseData && responseData.status && responseData.status._text ?
              parseInt(responseData.status._text, 10) :
              StatusCodes.UNKNOWN_ERROR;
          if (status === StatusCodes.UNKNOWN_ERROR) {
            return ResponseError.responseError(responseData);
          }

          return {
            status: status,
            data: AllFlightsConverter.allFlightsWireToInt(responseData.data),
          };
        })
        .catch(error => ResponseError.responseError(error))
    )
    .catch(error => ResponseError.responseError(error));
}

// function getAllFlights () {
//   return new Promise(resolve =>
//     resolve({
//       status: 0,
//       data: AllFlightsConverter.allFlightsWireToInt([
//         [
//           {
//             flight: [
//               {
//                 date: '21',
//                 daytxt: '21 - Sun',
//                 av_seats: '59',
//                 flightid: '2479',
//                 total_seats: '60',
//                 is_selectable: '1',
//                 bgcolor: '0xffff33',
//                 display: '59/60',
//               },
//               {
//                 date: '25',
//                 daytxt: '25 - Thu',
//                 av_seats: '60',
//                 flightid: '2515',
//                 total_seats: '60',
//                 is_selectable: '1',
//                 bgcolor: '0xffffff',
//                 display: '60/60',
//               },
//               {
//                 date: '28',
//                 daytxt: '28 - Sun',
//                 av_seats: '60',
//                 flightid: '2480',
//                 total_seats: '60',
//                 is_selectable: '1',
//                 bgcolor: '0xffff33',
//                 display: '60/60',
//               },
//             ],
//             name: 'Jan',
//             year: '2018',
//             av_seats: '179',
//             is_selectable: '1',
//             bgcolor: '0xffffff',
//           },
//           {
//             flight: [
//               {
//                 date: '1',
//                 daytxt: '1 - Thu',
//                 av_seats: '60',
//                 flightid: '2516',
//                 total_seats: '60',
//                 is_selectable: '1',
//                 bgcolor: '0xffffff',
//                 display: '60/60',
//               },
//               {
//                 date: '4',
//                 daytxt: '4 - Sun',
//                 av_seats: '60',
//                 flightid: '2481',
//                 total_seats: '60',
//                 is_selectable: '1',
//                 bgcolor: '0xffffff',
//                 display: '60/60',
//               },
//               {
//                 date: '8',
//                 daytxt: '8 - Thu',
//                 av_seats: '60',
//                 flightid: '2517',
//                 total_seats: '60',
//                 is_selectable: '1',
//                 bgcolor: '0xffffff',
//                 display: '60/60',
//               },
//               {
//                 date: '11',
//                 daytxt: '11 - Sun',
//                 av_seats: '60',
//                 flightid: '2482',
//                 total_seats: '60',
//                 is_selectable: '1',
//                 bgcolor: '0xffffff',
//                 display: '60/60',
//               },
//             ],
//             name: 'Feb',
//             year: '2018',
//             av_seats: '240',
//             is_selectable: '1',
//             bgcolor: '0xffffff',
//           },
//         ],
//       ]),
//     })
//   );
// }



// WEBPACK FOOTER //
// ./src/remoting/AllFlightsRemoting.js